import React, { useEffect, useMemo } from 'react'

import { Grid } from '@mui/material'
import Typography from '@mui/material/Typography'
import { Form, Formik } from 'formik'
import { useTranslation } from 'react-i18next'
import { useHistory, useParams } from 'react-router-dom'

import { MODAL_MODE, TEXTFIELD_REQUIRED_LENGTH } from '~/common/constants'
import { Field } from '~/components/Formik'
import Page from '~/components/Page'
import { ROUTE } from '../routes/config'
import ActionBar from '~/components/ActionBar'
import * as Yup from 'yup'
import { useAppStore } from '~/modules/shared/redux/hooks/useAppStore'

function Setting() {
  const { t } = useTranslation(['mkt'])
  const params = useParams()

  const {
    appStore: { isLoading, ...setting },
    actions,
  } = useAppStore()

  useEffect(() => {
    actions.getAppStore({})
  }, [])
  const initialValues = useMemo(() => {
    if (setting) {
      return {
        email: setting?.email || '',
        emailblacklist: setting?.emailblacklist || '',
      }
    }
    return {}
  }, [setting])

  const onSubmit = (values) => {
    const convertValues = {
      settings: [
        {
          name: 'email',
          value: values?.email,
        }, {
          name: 'emailblacklist',
          value: values?.emailblacklist,
        },
      ],
    }

    actions.updateAppStore(convertValues, () => {})
  }

  const renderActionBar = (handleReset) => {
    return <ActionBar onCancel={handleReset} mode={MODAL_MODE.UPDATE} />
  }

  return (
    <Page
      breadcrumbs={[
        {
          title: ROUTE.SETTING.TITLE,
        },
      ]}
      title={t('menu.setting')}
      loading={isLoading}
    >
      <Grid container justifyContent="center">
        <Grid item xl={11} xs={12}>
          <Formik
            initialValues={initialValues}
            validationSchema={() =>
              Yup.object().shape({
                email: Yup.string().required(t('form.required')),
                emailblacklist: Yup.string().required(t('form.required')),
              })
            }
            onSubmit={onSubmit}
            enableReinitialize
          >
            {({ handleReset, values }) => (
              <Form>
                <Grid item xs={12}>
                  <Typography variant="h4">
                    {t('userManagement.commonInfo')}
                  </Typography>
                </Grid>
                <Grid
                  container
                  rowSpacing={2}
                  sx={{
                    backgroundColor: '#DAE7F3',
                    marginTop: '5px',
                    padding: '0 15px 15px 15px',
                  }}
                  justifyContent="space-between"
                >
                  <Grid item lg={12} xs={12}>
                    <Field.TextField
                      name="email"
                      label={t('userManagement.emailNotification')}
                      placeholder={t('userManagement.emailNotification')}
                      inputProps={{
                        maxLength: TEXTFIELD_REQUIRED_LENGTH.EMAIL.MAX,
                      }}
                      required
                    />
                  </Grid> 
                  <Grid item lg={12} xs={12}>
                    <Field.TextField
                      name="emailblacklist"
                      label={t('userManagement.emailIngore')}
                      placeholder={t('userManagement.emailIngore')}
                      required
                    />
                  </Grid>
                  {renderActionBar(handleReset)}
                </Grid>
              </Form>
            )}
          </Formik>
        </Grid>
      </Grid>
    </Page>
  )
}

export default Setting
